import { Box, Typography } from "@mui/material";

/** 詳細ヘッダの指標タイル（資本金・従業員など） */
export const HeroStat: React.FC<{ label: string; value: string }> = ({
  label,
  value,
}) => (
  <Box
    sx={{
      px: 2,
      py: 1,
      borderRadius: 1,
      minWidth: 110,
      textAlign: "center",
      bgcolor: "action.hover",
    }}
  >
    <Typography variant="caption" color="text.secondary" display="block">
      {label}
    </Typography>
    <Typography variant="body2" fontWeight="bold" noWrap>
      {value}
    </Typography>
  </Box>
);
